import { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AppContext from '../../../shared/components/AppContext';
import { useConfirmationModalContext } from '../../../shared/components/ModalConfirmationContext';
import Logger from '../../../shared/services/Logger';
import * as constant from '../../../shared/util/constant';
import { userSetupUtils } from '../../../Admin/utils/UserSetupUtils';
import './AgencySideBar.scss';

interface Props {
    reload: boolean;
    onStateChange: (state: boolean) => void;
}

const AgencySideBar = (props: Props) => {
    const newBtn = props.onStateChange;

    const [groups, setGroups] = useState<any[]>([]);

    const modalContext = useConfirmationModalContext();

    const agencyGroupContext = useContext(AppContext);

    const history = useHistory();

    const { groupId } = useParams<{ groupId: string | undefined }>();

    const initializeAgencyGroup = async () => {
        try {
            let response = await userSetupUtils.getAgencyGroups();
            setGroups(response.sort());
        }
        catch (error) {
            toast.error(constant.ERROR_MESSAGE_LOAD, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: constant.AUTO_CLOSE
            });
            Logger.logError(error.toString());
        }
    }

    const handleAgencyGroupClick = async (agencyGroupId: string) => {
        newBtn(false);
        if (!agencyGroupContext.formSavedStatus) {
            const result = await modalContext.showConfirmation(constant.CONFIRM_EXIT)
            if (result) {
                agencyGroupContext.formSavedStatus = true
                history.push(`/maintenance/agency/${agencyGroupId}`)
            }
        }
        else {
            history.push(`/maintenance/agency/${agencyGroupId}`)
        }

    }

    useEffect(() => {
        initializeAgencyGroup();
    }, []);

    useEffect(() => {
        initializeAgencyGroup();
    }, [props.reload]);

    return (
        <div className='roles-sidebar d-flex flex-column overflow-auto' style={{ height: 'calc(100vh - 56px - 67px)' }}>
            {
                groups.map((groups) => (
                    <div
                        key={groups.value}
                        className={`role-item p-2 border-bottom ${groups.value === groupId ? 'active bg-light' : ''}`}
                        onClick={() => {
                            handleAgencyGroupClick(groups.value)
                        }}>
                        {groups.label}
                    </div>
                )
                )
            }
        </div>
    );
};

export default AgencySideBar;